import React from 'react'
import styled from 'styled-components'

/**
 * 要請後画面の固定エリア
 */
const FixedArea: React.FC<FixedAreaProps> = (props) => {
  return <StyledFixedArea>{props.children}</StyledFixedArea>
}

export type FixedAreaProps = {
  children: React.ReactNode
}

const StyledFixedArea = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`

export default FixedArea
